import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setShippingRateLogsAction,
  setShippingRateLogAction,
  setShippingRateLogsStatusAction,
  setShippingRateLogsErrorsAction,
  clearShippingRateLogsErrorsAction,
  setShippingRateLogsMetaAction
} from './shippingRateLogs.actions'

export const fetchShippingRateLogs =
  (params = {}) =>
  async dispatch => {
    try {
      dispatch(setShippingRateLogsStatusAction('loading'))
      dispatch(clearShippingRateLogsErrorsAction())

      const {
        data: { data: shippingRateLogs, meta }
      } = await branditRails.get('/shipping_rate_logs', { params })

      const logsById = shippingRateLogs.reduce((acc, log) => {
        acc[log.id] = log
        return acc
      }, {})

      dispatch(setShippingRateLogsAction(logsById))

      if (meta) {
        dispatch(
          setShippingRateLogsMetaAction({
            pageCount: meta.total_pages || 0,
            rowCount: meta.total_count || 0,
            currentPage: meta.current_page || 1,
            perPage: meta.per_page || 10
          })
        )
      }

      dispatch(setShippingRateLogsStatusAction('succeeded'))

      return shippingRateLogs
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message
      dispatch(setShippingRateLogsErrorsAction({ message: errorMessage }))
      dispatch(setShippingRateLogsStatusAction('failed'))
      toastr.error('Error', errorMessage)
      throw err
    }
  }

export const fetchShippingRateLog = logId => async dispatch => {
  try {
    dispatch(setShippingRateLogsStatusAction('loading'))
    dispatch(clearShippingRateLogsErrorsAction())

    const response = await branditRails.get(`/shipping_rate_logs/${logId}`)

    // API returns data directly at response.data, not response.data.data
    const shippingRateLog = response.data?.data || response.data
    console.log('Fetched shipping rate log:', shippingRateLog)

    dispatch(setShippingRateLogAction(shippingRateLog))
    dispatch(setShippingRateLogsStatusAction('succeeded'))

    return shippingRateLog
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setShippingRateLogsErrorsAction({ message: errorMessage }))
    dispatch(setShippingRateLogsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
